// src/reducers/tagReducer.js

import { ADD_TAG, GET_TAGS, SET_TAG_FETCHING, TAG_ERROR, TAG_RESET } from "../actions/tagTypes"
import { toast } from "react-toastify"

const initialState = {
    tags: null,
    fetching: false,
    fetchError: false
}

export const tagReducer = (state = initialState, action) => {
    switch(action.type){
        case ADD_TAG:
            if (!state.tags || state.tags.map(tag => tag._id).includes(action.payload._id)) return state
            return {
                ...state,
                tags: [action.payload,...state.tags || []]
            }
        case GET_TAGS:
            return {
                ...state,
                tags: action.payload
            }
        case TAG_ERROR:
            toast.error(
                <span style = {{ fontSize: "13.5px", fontFamily: 'Poppins, sans-serif'}}>
                   Unable to fetch tags. Try later.
                </span>,
                {
                    position: "bottom-left"
                }
            )
            return {
                ...state,
                fetchError: true
            }
        case SET_TAG_FETCHING:
            return {
                ...state,
                fetching: action.payload
            }
        case TAG_RESET:
            return {
                ...state,
                tags: null,
                fetching: false,
                fetchError: false
            }
        default:
            return state
    }
}